import { RootState } from '..';

export const fulfillmentMode = (state: RootState) => state.fulfillment.mode;

// Pickup is only actually usable once a branch has been chosen on the map —
// everywhere that skips delivery-address logic should gate on this, not on
// the tab alone.
export const isPickupSelected = (state: RootState) =>
  state.fulfillment.mode === 'pickup' && !!state.pickup?.branch?._id;
